import { motion } from "framer-motion";
import React from "react";

import * as styles from "./styles.module.css";

const SectionTitle = ({ message, white }) => {
  return (
    <h2 className={`${styles.title} ${white ? styles.white : null}`}>
      <motion.span
        initial={{ y: "1.2em" }}
        whileInView={{ y: 0 }}
        viewport={{ once: true }}
        transition={{
          delay: 0.2,
          duration: 0.4,
        }}
      >
        {message}
      </motion.span>
    </h2>
  );
};

export default SectionTitle;
